import React from "react";
import "../components.css";


export default function Row ({alignment = "left", children}: {alignment?: string, children?: React.ReactNode}) {

    let rowStyle = "";

    switch ( alignment ) {
        case "center":
            rowStyle = "center";
            break;
        case "right":
            rowStyle = "flex-end";
            break;
        case "left":
            rowStyle = "flex-start";
            break;
        default:
            rowStyle = "flex-start";
            break;
    }

    const style = {
        justifyContent: rowStyle
    }

    return (
        <div className="row" style={style}>
            {children}
        </div>
    )
}